module.exports = __webpack_public_path__ + "img/tips1_title.a204b191.jpg";